/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {UserModel, UsersService} from "@irian-ro/auth-web-client";
import {Observable} from "rxjs";
import {ToastMessageOptions} from "primeng/api";
import {ErrorService} from "@irian-ro/shared-components-module";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {UserDTOModel} from "@well/domain";
import {user} from "@angular/fire/auth";
import {UserPhoneDtoModel} from "../../../../../iriro-frontend-libs/auth-web-client/src/lib/user/user-phone-dto.model";

@Component({
  selector: 'well-sign-up-user',
  templateUrl: './sign-up-user.component.html',
  styleUrls: ['./sign-up-user.component.scss'],
})
export class SignUpUserComponent implements OnInit {

  errorMessages: Observable<ToastMessageOptions[]> | null = null;

  confirmEmailMessages: ToastMessageOptions[] = [];

  @ViewChild('form') form: NgForm | null = null;

  constructor(private usersService: UsersService,
              private errorService: ErrorService,
              private translateService: TranslateService,
              private router: Router) {
  }

  ngOnInit(): void {

  }

  submit() {
    this.form?.form?.markAllAsTouched();
    if (this.form) {
      if (this.form.valid) {
          const userModel : UserModel = this.form.value
          const userPhoneDTO : UserPhoneDtoModel = new UserPhoneDtoModel()
          userPhoneDTO.phoneNumber = this.form.value.phoneNumber
          userModel.userPhoneDTO = userPhoneDTO
        this.usersService.saveNewUserFromSignup(userModel)?.subscribe(
          {
            next: ((user: any) => {
              this.pushSuccessfulIfValidMessage();
              this.router.navigate(['/auth/login'], {queryParams: {statusMessages: JSON.stringify(this.confirmEmailMessages)}});
            }),
            error: (error: any) => {
              this.errorService.prepareErrorsForDisplay(error, 'signup.employee.error')
            }
          }
        );
      }
    }
  }

  pushSuccessfulIfValidMessage() {
    this.translateService.stream('signup.successfulIfValid').subscribe(
      message => {
        this.confirmEmailMessages = [];
        this.confirmEmailMessages.push(
          {
            severity: 'success',
            summary: message
          });
      }
    )
  }

}
